export const shortenAddress = (address: string = '', shortenTo: number = 4) =>
  `${address.slice(0, 2 + shortenTo)}...${address.slice(-shortenTo)}`;
